const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const { Base64 } = require('js-base64');
const getWs02Token = require('@dbk-legacy/wso2token').getToken;

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    'Content-Type': 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getUserAlerts(inputParam, metaData) {
      const url = getUrl('alerts');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      
      const params = JSON.parse(Base64.decode(inputParam));
      const body = {
        // category: params.category,
        language: params.language,
        userId: params.userId,
        module: params.module,
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },

    sendUserAlertSeenStatus(inputParam, metaData){
    const url = getUrl('alerts/seenStatus');
    const parsedMetaData = parseRequestMetaData(metaData);
    const reqOpts = {
      headers: merge(headers, parsedMetaData.headers),
      method: 'POST'
    };
    const params = JSON.parse(Base64.decode(inputParam));
    const body = {
      alertId: params.alertId,
      language: params.language,
      channel: params.channel,
      channelDetails: params.channelDetails,
      version: params.version,
      actionDetails: params.actionDetails,
      userId: params.userId,
     ...(params.alertDocId && {alertDocId: params.alertDocId})
    };
    return requestHandler(merge(reqOpts, {
      url,
      body,
      json: true,
    }));
      
    },

     getDowntime(inputParam, metaData) {
        const params = JSON.parse(Base64.decode(inputParam));
        
        let langCode = params.language
        langCode= langCode==="en"?"EN":"DE"
        const url = getUrl(`downtime/app?lang=${langCode}`);
        const reqOpts = {
          headers: merge(headers, {
            Authorization: getWs02Token(),
          }),
          method: 'GET'
        };

        return requestHandler(merge(reqOpts, {
          url,
          json: true,
        }));
    },

  };

}

module.exports = apiFactory;